import React from 'react';
import { StatsCard } from '@teetsh/app/src/containers/RegistreAppel/components/StatsCard';
import { AppelsStats } from '@teetsh/app/src/containers/RegistreAppel/types/appel';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

interface Props {
  data?: AppelsStats;
  print?: boolean;
}

export function AllStats({
  data,
  small,
  wrap,
  fill,
}: {
  data?: AppelsStats;
  small?: boolean;
  wrap?: boolean;
  fill?: boolean;
}) {
  const { t } = useTranslation(['registreAppel']);
  return (
    <>
      <StatsCard
        data-testId="totalAppels"
        small={small}
        wrap={wrap}
        grow={fill}
        stat={data?.totalAppels}
        name={t('registreAppel:totalHalfDays')}
      />
      <StatsCard
        data-testId="totalElevesAppels"
        small={small}
        wrap={wrap}
        grow={fill}
        disabled={data?.totalElevesAppels === undefined}
        stat={data?.totalElevesAppels}
        name={t('registreAppel:totalHalfDaysPossible')}
      />
      <StatsCard
        data-testId="totalAbsences"
        small={small}
        wrap={wrap}
        grow={fill}
        disabled={data?.totalAbsences === undefined}
        stat={data?.totalAbsences}
        name={t('registreAppel:totalAbsences')}
      />
      <StatsCard
        data-testId="totalRetards"
        small={small}
        wrap={wrap}
        grow={fill}
        disabled={data?.totalRetards === undefined}
        stat={data?.totalRetards}
        name={t('registreAppel:totalRetards')}
      />
      <StatsCard
        data-testId="totalAbsencesJustified"
        small={small}
        wrap={wrap}
        grow={fill}
        disabled={data?.totalAbsences === undefined}
        stat={data?.totalUnjustifiedAbsences}
        name={t('registreAppel:totalAbsencesUnjustified')}
      />
      <StatsCard
        data-testId="pourcentageAbsences"
        small={small}
        wrap={wrap}
        grow={fill}
        disabled={data?.pourcentageAbsences === undefined}
        stat={
          data?.pourcentageAbsences === undefined
            ? ''
            : `${data?.pourcentageAbsences}%`
        }
        name={t('registreAppel:percentageAbsences')}
      />
      <StatsCard
        data-testId="pourcentagePresences"
        small={small}
        wrap={wrap}
        grow={fill}
        disabled={data?.pourcentagePresences === undefined}
        stat={
          data?.pourcentagePresences === undefined
            ? ''
            : `${data?.pourcentagePresences}%`
        }
        name={t('registreAppel:percentagePresence')}
      />
    </>
  );
}

export function StatsCards(props: Props) {
  const { data, print } = props;
  return (
    <dl
      css={[
        tw`mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3 mb-5`,
        !print && tw`grid-cols-1 `,
        print && tw`grid-cols-3 `,
      ]}
    >
      <AllStats data={data} wrap={print} fill={print} />
    </dl>
  );
}
